import React, { useEffect, useState } from "react";
import { APIUrl, APIUrlToken } from "../../Utils/Utils";
import axios from "axios";
import "../AthleteDashboard/AdminDashboard.css";
import { toast } from "react-toastify";

const AthletePricingDashboard = ({
  activeMainTab,
  activePricingTab,
  setActivePricingTab,
  userData,
}) => {
  const [fanPricingData, setFanPricingData] = useState({});
  const [brandPricingData, setBrandPricingData] = useState({});
  const [backupData, setBackupData] = useState({});

  const [editMode, setEditMode] = useState({});
  const [editableData, setEditableData] = useState({});
  const [loading, setLoading] = useState(false);
  const FAN_PRICING_SECTIONS = [
    "generalSupport",
    "personalizedPost",
    "personalizedVideo",
    "meetGreet",
    "personInteraction",
  ];
  const DEFAULT_FAN_PRICING = {
    meetGreet: {
      sectionText: "Virtual Meet & Greet",
      sectionValue: "$30",
      options: [
        { pricingText: "15 min ($100)", pricingValue: "$100" },
        { pricingText: "30 min +$100", pricingValue: "+${100}" },
        { pricingText: "Over 30 min (inquire)", pricingValue: "inquire" },
      ],
    },

    generalSupport: {
      sectionText: "General Collaboration",
      sectionValue: "$90",
      options: [
        { pricingText: "Like ($25) per post", pricingValue: "$25" },
        { pricingText: "Follow/Subscribe ($25)", pricingValue: "$25" },
        { pricingText: "Comment ($75) per post", pricingValue: "$75" },
        { pricingText: "Share your channel ($150)", pricingValue: "$150" },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    personalizedPost: {
      sectionText: "Personalized Post",
      sectionValue: "$25",
      options: [
        { pricingText: "Under 50 words ($25)", pricingValue: "$25" },
        { pricingText: "50–100 words +$50", pricingValue: "+${50}" },
        { pricingText: "100–150 words +$75", pricingValue: "+${75}" },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    personInteraction: {
      sectionText: "In-Person Meet & Greet",
      sectionValue: "$150",
      options: [
        { pricingText: "5 min per person ($150)", pricingValue: "$150" },
        { pricingText: "Over 5 min (inquire)", pricingValue: "inquire" },
      ],
    },

    personalizedVideo: {
      sectionText: "Personalized Video Message",
      sectionValue: "$50",
      options: [
        { pricingText: "Under 30 sec ($50)", pricingValue: "$50" },
        { pricingText: "30 sec–1 min +$50", pricingValue: "+${50}" },
        { pricingText: "Over 1 min (inquire)", pricingValue: "inquire" },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },
  };
  const BRAND_PRICING_SECTIONS = [
    "socialMediaPost",
    "giveawaysContest",
    "storeAppearance",
    "limitedEditionProduct",
    "contentSeriesVlog",
    "livestreamPodcast",
    "discountCodesAffiliateLinks",
    "gameDayPromotion",
    "fanVotingCampaigns",
    "cameoStyleShoutout",
    "collectiveSponsored",
  ];
  const DEFAULT_BRAND_PRICING = {
    socialMediaPost: {
      sectionText: "Sponsored Social Media Post",
      sectionValue: "$1000",
      options: [
        { pricingText: "Under 50 words ($1000)", pricingValue: "$1000" },
        { pricingText: "50–100 words +$1000", pricingValue: "+$1000" },
        { pricingText: "100–150 words +$1500", pricingValue: "+$1500" },
        { pricingText: "Under 30 sec ($1000)", pricingValue: "$1000" },
        { pricingText: "30 sec–1 min +$3000", pricingValue: "+$3000" },
        { pricingText: "Over 1 min (inquire)", pricingValue: "custom" },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    storeAppearance: {
      sectionText: "In-Store Appearance / Pop-Up",
      sectionValue: "$2500",
      options: [
        { pricingText: "15 min ($2500)", pricingValue: "$2500" },
        { pricingText: "30 min +$1000", pricingValue: "+$1000" },
        { pricingText: "Over 30 min (inquire)", pricingValue: "custom" },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    gameDayPromotion: {
      sectionText: "Game Day Promotion",
      sectionValue: "$1500",
      options: [
        {
          pricingText:
            "Add-ons: In-stadium appearances / signage (pass-through)",
          pricingValue: "custom",
        },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    giveawaysContest: {
      sectionText: "Giveaways & Contest",
      sectionValue: "$1500",
      options: [
        {
          pricingText: "Add-ons: Prize fulfillment (pass-through), extra posts",
          pricingValue: "custom",
        },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    contentSeriesVlog: {
      sectionText: "Content Series / Vlog",
      sectionValue: "$2000",
      options: [
        { pricingText: "Under 15 min ($2500)", pricingValue: "$2500" },
        { pricingText: "15–30 min +$1500", pricingValue: "+$1500" },
        { pricingText: "Over 30 min (inquire)", pricingValue: "custom" },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    livestreamPodcast: {
      sectionText: "Livestream / Podcast",
      sectionValue: "$1500",
      options: [
        { pricingText: "Under 15 min ($2500)", pricingValue: "$2500" },
        { pricingText: "15–30 min +$1500", pricingValue: "+$1500" },
        { pricingText: "Over 30 min (inquire)", pricingValue: "custom" },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    cameoStyleShoutout: {
      sectionText: "Cameo-Style Shoutout",
      sectionValue: "$1000",
      options: [
        { pricingText: "Bulk packages available", pricingValue: "custom" },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    fanVotingCampaigns: {
      sectionText: "Fan Voting Campaigns",
      sectionValue: "$1500",
      options: [
        {
          pricingText: "Add-ons: Prize fulfillment (pass-through)",
          pricingValue: "custom",
        },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    collectiveSponsored: {
      sectionText: "Collective-Sponsored Engagement",
      sectionValue: "$2000",
      options: [
        { pricingText: "Custom retainers available", pricingValue: "custom" },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    limitedEditionProduct: {
      sectionText: "Limited-Edition Product Drop",
      sectionValue: "$1500",
      options: [
        {
          pricingText: "Rev-share or flat fee (by agreement)",
          pricingValue: "agreement",
        },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },

    discountCodesAffiliateLinks: {
      sectionText: "Discount Codes / Affiliate Links",
      sectionValue: "$1500",
      options: [
        { pricingText: "Commission (by agreement)", pricingValue: "agreement" },
        {
          pricingText: "Multiple Requests (please specify)",
          pricingValue: "custom",
        },
      ],
    },
  };

  const getFanPricing = async () => {
    if (!userData?.player_id) return;
    try {
      const res = await axios.get(
        `${APIUrl()}/v1/fan_engagement_pricing/by_player/${
          userData?.player_id
        }`,
        {
          headers: { "X-API-Key": APIUrlToken() },
          params: { player_id: userData.player_id },
        }
      );
      const data = res.data?.config;

      if (!data || Object.keys(data).length === 0) {
        setFanPricingData(DEFAULT_FAN_PRICING);
      } else {
        setFanPricingData(data);
      }
      // setFanPricingData(res.data.config || {});
    } catch (error) {
      setFanPricingData(DEFAULT_FAN_PRICING);
      console.error("Failed to fetch fan engagement pricing", error);
    }
  };

  // Fetch Brand Pricing
  const getBrandPricing = async () => {
    if (!userData?.player_id) return;
    try {
      const res = await axios.get(
        `${APIUrl()}/v1/brand_engagement_pricing/by_player/${
          userData?.player_id
        }`,
        {
          headers: { "X-API-Key": APIUrlToken() },
          params: { player_id: userData.player_id },
        }
      );
      const data = res.data?.config;

      // Use fallback if API gives empty/null
      if (!data || Object.keys(data).length === 0) {
        setBrandPricingData(DEFAULT_BRAND_PRICING);
      } else {
        setBrandPricingData(data);
      }
      // setBrandPricingData(res.data.config || {});
    } catch (error) {
      setBrandPricingData(DEFAULT_BRAND_PRICING);
      console.error("Failed to fetch brand engagement pricing", error);
    }
  };

  useEffect(() => {
    if (userData?.player_id) {
      getFanPricing();
      getBrandPricing();
    }
  }, [userData?.player_id]);

  // Helpers
  const formatHeading = (key) =>
    key
      ? key
          .replace(/([A-Z])/g, " $1") // Add space before capital letters
          .replace(/_/g, " ") // Replace only underscores
          .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
      : "";

  const normalizeOptions = (options) => {
    if (!options) return [];
    if (Array.isArray(options)) return options;
    if (typeof options === "object") return Object.values(options);
    return [options];
  };

  // Toggle Edit Mode

  const toggleEditMode = (categoryKey, data) => {
    const activeData =
      activePricingTab === "fan" ? fanPricingData : brandPricingData;

    // store full backup
    setBackupData((prev) => ({
      ...prev,
      [categoryKey]: JSON.parse(JSON.stringify(activeData[categoryKey])),
    }));

    setEditMode((prev) => ({
      ...prev,
      [categoryKey]: !prev[categoryKey],
    }));

    setEditableData((prev) => ({
      ...prev,
      [categoryKey]: normalizeOptions(data),
    }));
  };

  // const toggleEditMode = (categoryKey, data) => {
  //   setEditMode((prev) => ({
  //     ...prev,
  //     [categoryKey]: !prev[categoryKey],
  //   }));
  //   setEditableData((prev) => ({
  //     ...prev,
  //     [categoryKey]: normalizeOptions(data),
  //   }));
  // };

  // Handle input change
  const handleInputChange = (categoryKey, index, field, value) => {
    setEditableData((prev) => {
      const updated = [...(prev[categoryKey] || [])];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, [categoryKey]: updated };
    });
  };

  // Add new row
  const handleAddRow = (categoryKey) => {
    setEditableData((prev) => ({
      ...prev,
      [categoryKey]: [
        ...(prev[categoryKey] || []),
        { pricingText: "", pricingValue: "" },
      ],
    }));
  };

  // Delete row
  const handleDeleteRow = (categoryKey, index) => {
    setEditableData((prev) => {
      const updated = [...(prev[categoryKey] || [])];
      updated.splice(index, 1);
      return { ...prev, [categoryKey]: updated };
    });
  };

  // Cancel edit
  const handleCancel = (categoryKey) => {
    const activeDataSetter =
      activePricingTab === "fan" ? setFanPricingData : setBrandPricingData;

    // Restore backup
    activeDataSetter((prev) => ({
      ...prev,
      [categoryKey]: backupData[categoryKey],
    }));

    // Restore editable options
    setEditableData((prev) => ({
      ...prev,
      [categoryKey]: normalizeOptions(backupData[categoryKey]?.options || []),
    }));

    setEditMode((prev) => ({ ...prev, [categoryKey]: false }));
  };

  // const handleCancel = (categoryKey) => {
  //   setEditMode((prev) => ({ ...prev, [categoryKey]: false }));
  //   setEditableData((prev) => ({
  //     ...prev,
  //     [categoryKey]: normalizeOptions(
  //       activePricingTab === "fan"
  //         ? fanPricingData[categoryKey]
  //         : brandPricingData[categoryKey]
  //     ),
  //   }));
  // };

  const handleSave = async (categoryKey) => {
    const updatedOptions = editableData[categoryKey];
    const activeData =
      activePricingTab === "fan" ? fanPricingData : brandPricingData;

    const newData = {
      ...activeData,
      [categoryKey]: {
        ...(activeData[categoryKey] || {}),
        options: updatedOptions,
      },
    };

    try {
      setLoading(true);

      const apiUrl =
        activePricingTab === "fan"
          ? `${APIUrl()}/v1/fan_engagement_pricing`
          : `${APIUrl()}/v1/brand_engagement_pricing`;

      await axios.put(
        apiUrl,
        {
          user_id: userData?.user_id || 0,
          config: newData,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        },
        {
          headers: {
            "X-API-Key": APIUrlToken(),
            "Content-Type": "application/json",
          },
        }
      );

      if (activePricingTab === "fan") {
        setFanPricingData(newData);
        await getFanPricing();
      } else {
        setBrandPricingData(newData);
        await getBrandPricing();
      }

      setEditMode((prev) => ({ ...prev, [categoryKey]: false }));
      toast.success("Pricing updated successfully!");
    } catch (error) {
      console.error("Error updating pricing:", error);
      toast.error("Failed to update pricing!");
    } finally {
      setLoading(false);
    }
  };

  const renderCategoryTable = (categoryKey, categoryDataRaw) => {
    const categoryData = categoryDataRaw || {};

    const options = normalizeOptions(categoryData.options);
    const isEditing = editMode[categoryKey];
    const editableOptions = editableData[categoryKey] || options;
    const handleSectionChange = (categoryKey, field, value) => {
      if (activePricingTab === "fan") {
        setFanPricingData((prev) => ({
          ...prev,
          [categoryKey]: {
            ...prev[categoryKey],
            [field]: value,
          },
        }));
      } else {
        setBrandPricingData((prev) => ({
          ...prev,
          [categoryKey]: {
            ...prev[categoryKey],
            [field]: value,
          },
        }));
      }
    };

    return (
      <div className="editable-card" key={categoryKey}>
        <div className="editable-card-header">
          <h4 className="editable-card-title">
            {/* {formatHeading(categoryData.sectionText || categoryKey)} */}
            {activePricingTab === "fan"
              ? DEFAULT_FAN_PRICING[categoryKey]?.sectionText
              : DEFAULT_BRAND_PRICING[categoryKey]?.sectionText}{" "}
          </h4>
          <div className="editable-actions">
            {!isEditing ? (
              <button
                className="editable-btn editable-edit-btn"
                onClick={() => toggleEditMode(categoryKey, options)}
              >
                Edit
              </button>
            ) : (
              <>
                <button
                  type="button"
                  onClick={() => handleCancel(categoryKey)}
                  className="editable-btn editable-cancel-btn"
                >
                  Cancel
                </button>
                {/* <button
                  className="editable-btn editable-add-btn"
                  onClick={() => handleAddRow(categoryKey)}
                >
                  Add
                </button> */}
                <button
                  className="editable-btn editable-save-btn"
                  onClick={() => handleSave(categoryKey)}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </button>
              </>
            )}
          </div>
        </div>

        {/* Section Info */}
        <div className="section-info">
          {/* <p className="selected-text-athlete">
            <strong>Section Text:</strong>{" "}
            {isEditing ? (
              <input
                type="text"
                className="editable-input"
                value={categoryData.sectionText || ""}
                onChange={(e) =>
                  handleSectionChange(
                    categoryKey,
                    "sectionText",
                    e.target.value
                  )
                }
              />
            ) : (
              categoryData.sectionText || "-"
            )}
          </p> */}
          <p className="selected-text-athlete">
            <strong>Section Amount:</strong>{" "}
            {isEditing ? (
              <input
                type="text"
                className="editable-input"
                value={categoryData.sectionValue || ""}
                onChange={(e) =>
                  handleSectionChange(
                    categoryKey,
                    "sectionValue",
                    e.target.value
                  )
                }
              />
            ) : (
              categoryData.sectionValue || "-"
            )}
          </p>
        </div>

        {/* Options Table */}
        {/* <table className="editable-table">
          <thead>
            <tr>
              <th>Pricing Option</th>
              <th>Amount</th>
              {isEditing && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {editableOptions.map((item, idx) => (
              <tr key={idx}>
                <td>
                  {isEditing ? (
                    <input
                      type="text"
                      className="editable-input"
                      value={item.pricingText || ""}
                      onChange={(e) =>
                        handleInputChange(
                          categoryKey,
                          idx,
                          "pricingText",
                          e.target.value
                        )
                      }
                      placeholder="Enter Pricing Option"
                    />
                  ) : (
                    item.pricingText || "-"
                  )}
                </td>
                <td>
                  {isEditing ? (
                    <input
                      type="text"
                      className="editable-input"
                      value={item.pricingValue || ""}
                      onChange={(e) =>
                        handleInputChange(
                          categoryKey,
                          idx,
                          "pricingValue",
                          e.target.value
                        )
                      }
                      placeholder="Enter Value"
                    />
                  ) : (
                    item.pricingValue || "-"
                  )}
                </td>
                {isEditing && (
                  <td>
                    <button
                      className="editable-btn editable-delete-btn"
                      onClick={() => handleDeleteRow(categoryKey, idx)}
                    >
                      Delete
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table> */}
      </div>
    );
  };

  return (
    <div>
      {activeMainTab === "pricing" && (
        <div className="pricing-dashboard-container">
          {/* Sub Tabs */}
          <div className="pricing-sub-tabs">
            <div
              className={`pricing-sub-tab ${
                activePricingTab === "fan" ? "active" : ""
              }`}
              onClick={() => setActivePricingTab("fan")}
            >
              Fan Engagement Pricing
            </div>
            <div
              className={`pricing-sub-tab ${
                activePricingTab === "brand" ? "active" : ""
              }`}
              onClick={() => setActivePricingTab("brand")}
            >
              Brand Partnership Pricing
            </div>
          </div>

          {/* Pricing Content */}
          <div className="pricing-content">
            {activePricingTab === "fan"
              ? FAN_PRICING_SECTIONS.map((category) => {
                  const data = fanPricingData?.[category] || [];
                  return renderCategoryTable(category, data);
                })
              : BRAND_PRICING_SECTIONS.map((category) => {
                  const data = brandPricingData?.[category] || [];
                  return renderCategoryTable(category, data);
                })}
          </div>
        </div>
      )}
    </div>
  );
};
export default AthletePricingDashboard;
